import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle",
      animation: 150,
      draggable: "[data-category-id]",
      onEnd: (event) => this.reorder(event)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  reorder(event) {
    const categoryId = event.item.dataset.categoryId
    const position = event.newIndex + 1
    const locale = new URLSearchParams(window.location.search).get("locale") || ""
    const localeParam = locale ? `?locale=${locale}` : ""

    fetch(`/categories/${categoryId}/reorder${localeParam}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ position })
    })
      .then(response => response.text())
      .then(html => {
        if (html) Turbo.renderStreamMessage(html)
      })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
